import React from "react";
import { Button, Icon } from "react-materialize";
// import MenuItem from "components/infos/MenuItem";
// import { useHistory } from "react-router-dom";

export default function LeftContent({ userData }) {
  //const history = useHistory();
  // const tabActive = "notification";

  // const handleEvents = {
  //   MenuItem: {
  //     OnClick: function (data) {
  //       if (data?.disable) return;
  //       let path = "";
  //       if (data.id === "myprofile") {
  //         path = "/employees/myprofile";
  //       } else {
  //       }
  //       history.push(path);
  //     },
  //   },
  // };

  return (
    <ul
      id="notify-leftcontent"
      className="col s2 collection"
      style={{
        padding: "0",
        marginTop: "0px",
        border: "none",
      }}
    >
      {/* <MenuItem
        data={{
          id: "notification",
          text: "Notification",
          tabActive: tabActive,
          disable: false,
        }}
        handleEvents={handleEvents.MenuItem}
      /> */}
      <li style={{ marginTop: "15px" }}>
        <Button flat node="a" waves="light" href={"/employees"}>
          BACK
          <Icon left>arrow_back</Icon>
        </Button>
      </li>
    </ul>
  );
}
